import { MedicalOrderScann } from "../medical-order-scann";
import { ValorizationEdit } from "../valorization-edit";
import { BudgetPlan } from "./budget-plan";

export class Budget {
  constructor() {
    this.Plan = new BudgetPlan();
    this.Scanns = [];
  }

  PhysicianId?: number;
  CenterId: number;
  ServiceId?: number;
  EquipmentId?: number;
  PatientId?: number;
  FinalizeDate: Date;
  Date: Date;
  Name: string;
  Observation: string;
  BudgetText: string;
  Plan: BudgetPlan;
  Scanns: MedicalOrderScann[];
  ValorizationEdit?: ValorizationEdit;
}
